module.exports = __webpack_public_path__ + "img/CropSprayer.c75dc5d7.png";